import { Link } from "react-router-dom";
import PartnerLogoStrip from './PartnerLogoStrip';

export default function Footer() {
    return (
        <footer className="bjnt-footer bjnt-footer--sponsor-first">
            <section className="container">
                <div className="bjnt-footer-sponsor-head">
                    <h2>Proudly Supporting <br />Crop Over Music.</h2>
                </div>

                <PartnerLogoStrip mode="dark" title="" compact />

                <div className="bjnt-footer-bottom">
                    <nav className="bjnt-footer-links" aria-label="Footer navigation">
                        <Link to="/">Music</Link>
                        <Link to="/giveaway">Giveaways</Link>
                        <Link to="/giveaway/how-to-win">How to Win</Link>
                        <Link to="/upload">Upload Music</Link>
                    </nav>

                    <div className="bjnt-footer-credit">
                        <span>© {new Date().getFullYear()} Bajantube</span>
                        <span>Built by ByteBot Tech Inc.</span>
                    </div>
                </div>
            </section>
        </footer>
    );
}